export const regex = {
  email:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  lowerUpperCase: /^(?!\s)(?!.*\s$)(?!.*?(\s)\1)(?=.*?[A-Z])(?=.*?[a-z]).+$/,
  digit: /\d/,
  specialCharacter: /(?=.*[!@#$%^&*()_+\-=,.;:'"[\]{}|`~<>?\\/])/,
  minLength: (length) => new RegExp(`^.{${length}}`),
};
